var _polygon, _path, _path2, _path3, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "523.079px",
    height: "112.518px",
    viewBox: "0 0 523.079 112.518",
    enableBackground: "new 0 0 523.079 112.518",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    points: "447.877,38.476 473.631,75.561 454.059,104.404 447.877,112.646  470.542,112.646 484.963,92.042 499.385,112.646 523.079,112.646 516.898,104.404 496.295,75.561 523.079,38.476 499.385,38.476  484.963,59.078 470.542,38.476 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.142,37.506c-20.73,0-37.532,16.794-37.532,37.506 s16.802,37.506,37.532,37.506c13.648,0,26.229-7.409,32.837-19.347l-16.419-9.079c-3.306,5.969-9.597,9.676-16.418,9.676 c-10.365,0-18.769-8.396-18.769-18.756h56.298C453.671,54.3,436.867,37.506,416.142,37.506L416.142,37.506z M416.142,56.261 c6.701,0,12.897,3.575,16.246,9.376H399.89C403.239,59.836,409.434,56.261,416.142,56.261z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.698,37.506c-20.73,0-37.532,16.794-37.532,37.506 s16.802,37.506,37.532,37.506c20.726,0,37.53-16.794,37.53-37.506V0H350.46v42.531C344.759,39.24,338.284,37.506,331.698,37.506 L331.698,37.506z M331.698,56.261c10.36,0,18.763,8.398,18.763,18.75c0,10.359-8.402,18.756-18.763,18.756 c-10.365,0-18.768-8.396-18.768-18.756C312.93,64.659,321.333,56.261,331.698,56.261z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.253,37.506c-20.725,0-37.53,16.794-37.53,37.506v37.506h18.768V75.012 c0-10.353,8.397-18.75,18.763-18.75c10.361,0,18.764,8.398,18.764,18.75v37.506h18.768V75.012 C284.785,54.3,267.979,37.506,247.253,37.506z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    points: "200.134,112.646 200.134,39.505 200.134,38.476 181.592,38.476  181.592,112.646  "
  }), /*#__PURE__*/React.createElement("circle", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    cx: 190.959,
    cy: 9.378,
    r: 9.378
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "#000000",
    strokeWidth: 0.1809,
    strokeMiterlimit: 10,
    d: "M100.448,42.59 L74.072,95.342c-0.562-3.82-2.335-7.357-5.063-10.086l0,0l-15.191-15.19l26.376-52.75c0.555,3.811,2.333,7.355,5.063,10.083l0,0 L100.448,42.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0480B7",
    stroke: "#0480B7",
    strokeWidth: 0.1809,
    strokeMiterlimit: 10,
    d: " M118.746,97.937L118.746,97.937c4.937-4.946,7.724-11.656,7.724-18.649c0-8.063-3.685-15.68-10.009-20.683l0,0L87.533,87.532 c-2.754,2.764-4.308,6.508-4.308,10.404c0,8.128,6.593,14.71,14.712,14.71c3.904,0,7.65-1.552,10.404-4.306l0,0L118.746,97.937z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0480B7",
    stroke: "#0480B7",
    strokeWidth: 0.1809,
    strokeMiterlimit: 10,
    d: " M35.521,14.711c-4.946,4.947-7.727,11.657-7.727,18.65c0,8.062,3.688,15.686,10.002,20.683l0,0l28.938-28.928 c2.754-2.753,4.306-6.5,4.306-10.404C71.04,6.593,64.449,0,56.33,0c-3.906,0-7.65,1.554-10.404,4.317l0,0L35.521,14.711z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.1809,
    strokeMiterlimit: 10,
    d: " M35.521,14.711L4.308,45.924C1.554,48.679,0,52.423,0,56.329c0,3.897,1.554,7.641,4.308,10.405l0,0l41.617,41.607 c2.754,2.754,6.498,4.306,10.404,4.306c8.119,0,14.71-6.582,14.71-14.71c0-3.896-1.552-7.641-4.306-10.404l0,0L35.521,56.329 c-5.518-5.518-8.617-13.008-8.617-20.809C26.904,27.72,30.003,20.229,35.521,14.711z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.1809,
    strokeMiterlimit: 10,
    d: " M118.746,97.937c5.518-5.518,8.614-12.999,8.614-20.809c0-7.801-3.097-15.284-8.614-20.799l0,0L87.533,25.116 c-2.754-2.753-4.308-6.5-4.308-10.404C83.225,6.593,89.818,0,97.937,0c3.904,0,7.65,1.554,10.404,4.317l0,0l41.607,41.607 c2.764,2.754,4.315,6.499,4.315,10.404c0,3.897-1.552,7.641-4.315,10.405l0,0L118.746,97.937z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.e057cb5fd446c20c53d1aaabaee8f8af.svg";
export { ForwardRef as ReactComponent };